import styled from '@emotion/styled';
import { Title } from '@radix-ui/react-dialog';

export const StyledFacetsOverlayTitle = styled(Title)(({ theme }) => ({
	fontSize: theme.fontSizes.lg,
	textTransform: 'uppercase',
	letterSpacing: '3px',
}));

export const FacetsOverlayTitle = StyledFacetsOverlayTitle;
